import React from 'react';

import { EmbedCodeSnippetConfig } from './EmbedCodeSnippetConfig';
import { HighlightedText } from './HighlightedText';

export const ReactNpmSnippet = ({
  graphRefString,
  persistChangesInEmbedConfig,
  document,
  hideHeadersAndEnvVarsInEmbedConfig,
  headers,
  variables,
  docsPanelState,
  theme,
  autoInviteOptions,
}: EmbedCodeSnippetConfig) => (
  <>
    {`import { ApolloExplorer } from '@apollo/explorer/react';
  `}
    {`
export function EmbeddedExplorer() {
  return (
    <ApolloExplorer 
      graphRef=`}
    '<HighlightedText>{graphRefString}</HighlightedText>'
    {autoInviteOptions && (
      <>
        {`
      autoInviteOptions={{
        inviteToken: `}
        '<HighlightedText>{autoInviteOptions.inviteToken}</HighlightedText>'
        {`,
        accountId: `}
        '<HighlightedText>{autoInviteOptions.accountId}</HighlightedText>'
        {`,
      }}`}
      </>
    )}
    {`
      persistExplorerState={`}
    <HighlightedText>{persistChangesInEmbedConfig.toString()}</HighlightedText>
    {`}
      initialState={{
        document: `}
    <HighlightedText>{`\`${document}\``}</HighlightedText>
    {`,
        variables: `}
    <HighlightedText>{variables}</HighlightedText>
    {`,
        headers: `}
    <HighlightedText>{headers}</HighlightedText>
    {`,
        displayOptions: {
          showHeadersAndEnvVars: `}
    <HighlightedText>
      {(!hideHeadersAndEnvVarsInEmbedConfig).toString()}
    </HighlightedText>
    {`, 
          docsPanelState: `}
    '<HighlightedText>{docsPanelState}</HighlightedText>'
    {`, 
          theme: `}
    '<HighlightedText>{theme}</HighlightedText>
    ',
    {`
        },
      }}
    />
  );
}
`}
  </>
);
